import { render, staticRenderFns } from "./BackHeader.vue?vue&type=template&id=02b7b779&scoped=true&"
import script from "./BackHeader.vue?vue&type=script&lang=js&"
export * from "./BackHeader.vue?vue&type=script&lang=js&"
import style0 from "./BackHeader.vue?vue&type=style&index=0&id=02b7b779&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02b7b779",
  null
  
)

export default component.exports